<template>
	<transition-expand>
		<div class="validation_errors">
			<span class="validation_errors__icon icon icon-warning" />
			<ul class="validation_errors__list">
				<li
					v-for="(error, index) in errors"
					:key="index"
					class="validation_errors__item"
				>
					<span
						v-html="error"
						role="alert"
						class="p4 validation_errors__message"
					/>
				</li>
			</ul>
		</div>
	</transition-expand>
</template>

<script>
import TransitionExpand from "@vg-faset/ui/src/components/transitions/TransitionExpand";

export default {
	name: "ValidationErrors",

	components: {
		TransitionExpand
	},

	props: {
		errors: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style lang="scss" scoped>
.validation_errors {
	display: flex;
}

.validation_errors__icon {
	flex: 0 0 auto;
	color: $color--red-5;
}

.validation_errors__list {
	flex: 1 1 auto;
	margin: 0 0 0 8px;
}

.validation_errors__item {
	color: $color--red-5;
	line-height: 1;
	list-style-type: none;
	margin: 0;
	padding: 0;
}

.validation_errors__message {
	vertical-align: top;
}
</style>
